<template>
    <div
        :id="id"
        :class="classes"
        class="transactionlink-component-space"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    configuration?: {
        size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    }
    hasCustomWidth?: boolean
}>()

const classes = computed(() => ({
    xsmall: props.configuration?.size?.toLowerCase() === 'xs',
    small: props.configuration?.size?.toLowerCase() === 'sm',
    medium: props.configuration?.size?.toLowerCase() === 'md',
    large: props.configuration?.size?.toLowerCase() === 'lg',
    xlarge: props.configuration?.size?.toLowerCase() === 'xl',
    'custom-width': props.hasCustomWidth,
}))
</script>

<style lang="sass" scoped>
@import "./EmptySpace.sass"
</style>
